import React from 'react';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import { Role, ROLE_DETAILS, useAuth } from '@/state/AuthContext';

interface RoleGateProps {
  allowedRoles: Role[];
  children: React.ReactNode;
}

const RoleGate: React.FC<RoleGateProps> = ({ allowedRoles, children }) => {
  const { role } = useAuth();
  const isAllowed = role ? (allowedRoles as string[]).includes(role) : false;

  if (isAllowed) {
    return <>{children}</>;
  }

  const allowedLabels = allowedRoles.map((allowedRole) => ROLE_DETAILS[allowedRole].label);

  return (
    <div className="glass-panel mx-auto mt-20 max-w-3xl space-y-4 p-10 text-center">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-blue/10 text-brand-blue">
        <LockClosedIcon className="h-7 w-7" />
      </div>
      <h2 className="text-2xl font-semibold text-slate-900">存取受限</h2>
      <p className="text-sm text-slate-500">
        此模組僅供{' '}
        <span className="font-semibold text-slate-900">{allowedLabels.join(' 或 ')}</span> 使用，
        可透過上方的角色切換器預覽該角色的工作流程。
      </p>
    </div>
  );
};

export default RoleGate;
